<template>
	<div>
		<h2 class="header text-capitalize pb-xl-5 p-4">Create Survey</h2>
		<div class="d-flex justify-content-center survey-types">
			<div
				v-for="(item, index) in surveyTypeCardContent"
				:key="item.title"
				class="card-content"
			>
				<survey-type-card :content="item" :index="index"></survey-type-card>
			</div>
		</div>
		<transition name="fade">
			<div
				v-if="CreateFormStatus"
				class="modal-layout position-fixed d-flex justify-content-center align-items-center"
			>
				<create-new-survey-form></create-new-survey-form>
			</div>
		</transition>
	</div>
</template>

<script>
import SurveyTypeCard from "@/components/create-survey-journey/survey-type-card.vue";
import CreateNewSurveyForm from "@/components/create-survey-journey/create-new-survey-form.vue";

export default {
	name: "SelectSurveyType",
	components: {
		SurveyTypeCard,
		CreateNewSurveyForm,
	},
	data() {
		return {
			surveyTypeCardContent: [
				{
					shadow: "#C77D7D9A",
					type: "red",
					alt: "Rapid Engagement Diagnostic",
					description: "Rapid Engagement Diagnostic<br> 32 Created | 56 Closed",
					body:
						"Rapid Engagement Diagnostic has 4 core questions all related to customer experience. It is recommended to run this survey at least once every quarter",
					dropUpList: [
						{
							header: "create new survey",
							body:
								"Start fresh, you will go through the full survey creation process",
							class: "",
							type: "create",
						},
						{
							header: "copy existing survey",
							body:
								"Work smart! if you have a previous survey saved, use it as a template for a new one!",
							class: "mt-3",
							type: "copy",
						},
					],
				},
				{
					shadow: "#6b7aacb5",
					type: "yes",
					alt: "Yearly Engagement Diagnostic",
					description: "Yearly Engagement Diagnostic<br> 3 Created | 4 Closed",
					body:
						"Yearly Engagement Score has 12 core questions covering the experience, network, commitment and loyalty of the customers. It is recommended to run these surveys on a yearly basis",
					dropUpList: [
						{
							header: "create new survey",
							body:
								"Start fresh, you will go through the full survey creation process",
							class: "",
							type: "create",
						},
						{
							header: "copy existing survey",
							body:
								"Work smart! if you have a previous survey saved, use it as a template for a new one!",
							class: "mt-3",
							type: "copy",
						},
					],
				},
			],
		};
	},
	computed: {
		CreateFormStatus() {
			return this.$store.getters["surveyJourney/CreateFormStatus"];
		},
	},
	mounted() {
		try {
			this.$store.dispatch("surveyJourney/getProducts");
			this.$store.dispatch("surveyJourney/getCustomerGroup");
		} catch (error) {
			this.$store.dispatch("dialog/showErrorDialog", {
				error: error,
			});
		}
	},
};
</script>

<style lang="scss" scoped>
.header {
	top: 0;
}
.card-content {
	width: 600px;
}
</style>
